import React from 'react';
import { FormGroup } from '~/components/form';
import { useForm } from '~/hooks';


export const InsuredIndividual= (props) => {

    const {
        onInsuredIndividualChange,
        detailData
    } = props;

    const defaultState = {
        insuredFirstName: detailData? detailData.insuredFirstName : '',
        insuredMiddleName: detailData? detailData.insuredMiddleName : '',
        insuredLastName: detailData? detailData.insuredLastName : '',
        insuredSuffix: detailData? detailData.insuredSuffix : ''
    };

    const { state, fieldActions } = useForm({
        initialState: { ...defaultState },
        debug: true
    });
    return (
        <div className="row grid grid-cols-4 grid-flow-row gap-x-2 gap-y-4 text-sm mb-4">  
            <FormGroup
                label="First"
                required
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path={'insuredFirstName'}
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.insuredFirstName && 'Limit to 12 characters.'}                  
                value={state.values.insuredFirstName}
                error={state.errors.insuredFirstName}
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'insuredFirstName');
                    onInsuredIndividualChange(state.values);
                }}
            />
            <FormGroup
                label="Middle"
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='insuredMiddleName'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.insuredMiddleName && 'Limit to 12 characters.'}  
                value={state.values.insuredMiddleName}
                error={state.errors.insuredMiddleName}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'insuredMiddleName');
                    onInsuredIndividualChange(state.values);
                }}
            />
            <FormGroup
                label="Last"
                required
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='insuredLastName'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.insuredLastName && 'Limit to 12 characters.'}  
                value={state.values.insuredLastName}
                error={state.errors.insuredLastName}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'insuredLastName');   
                    onInsuredIndividualChange(state.values);                 
                }}
            />
            <FormGroup
                label="Suffix"
                groupClassName="col-span-1"
                inputClassName="w-full border-1 border-gray-200 rounded bg-gray-50"
                path='insuredSuffix'
                maxLength={12}
                validator={value=> value.length < 12 ? true : state.values.insuredSuffix && 'Limit to 12 characters.'}  
                value={state.values.insuredSuffix}
                error={state.errors.insuredSuffix}
                autoComplete='no'
                {...fieldActions}
                onChange={(value) => {
                    fieldActions.onChange(value, 'insuredSuffix');
                    onInsuredIndividualChange(state.values);
                }}
            />             
        </div>
    );
};


export default InsuredIndividual;
